import '../style.css';
import './style.css';
import { relatedToolsMarkup, siteBrandMarkup } from '../site-chrome';
import { createReportCardApp } from './ui/app';
import { PRIVACY_LINE, TOOL_SUBTITLE, TOOL_TITLE } from './ui/copy';
import { requireElement } from './ui/dom';
import { detectUiEnvironment, previewUserAgent, TOOL_PATH, TOOL_URL } from './ui/environment';
import { icon } from './ui/icons';
import { createBrowserIntakeApi } from './ui/intake-adapter';
import type { IntakeApi } from './ui/intake-api';
import { createToast } from './ui/toast';

const root = document.querySelector<HTMLDivElement>('#app');
if (!root) throw new Error('카톡 성적표 화면을 찾지 못했어요.');
document.documentElement.classList.add('krc-page');

root.innerHTML = `
  <div class="page-shell krc-shell" data-krc-screen="start">
    <div class="blob blob-one" aria-hidden="true"></div>
    <div class="blob blob-two" aria-hidden="true"></div>
    <header class="site-brand-header">${siteBrandMarkup()}</header>
    <main class="krc-main">
      <section class="tool-intro krc-intro" aria-labelledby="krc-title">
        <span class="tool-kicker">오늘의 놀이</span>
        <h1 id="krc-title">${TOOL_TITLE}</h1>
        <p class="krc-intro-text">${TOOL_SUBTITLE}</p>
        <p class="krc-privacy-line">${icon('lock')}<span>${PRIVACY_LINE}</span></p>
      </section>
      <div class="krc-stage" id="krc-stage"></div>
      ${relatedToolsMarkup('kakao-report-card')}
    </main>
    <footer class="legal-footer"><a href="/privacy/">개인정보처리방침</a><a href="/terms/">이용약관</a><span>© 2026 오늘툴</span></footer>
    <div class="krc-toast" id="krc-toast" role="status" aria-live="polite"></div>
  </div>`;

const params = new URLSearchParams(location.search);
// Dev-only: ?inapp=android|ios emulates the KakaoTalk in-app browser.
const devUserAgent = import.meta.env.DEV ? previewUserAgent(params.get('inapp')) : null;
const pageUrl = location.protocol === 'https:' ? new URL(TOOL_PATH, location.origin).href : TOOL_URL;
const environment = detectUiEnvironment(devUserAgent ?? navigator.userAgent, devUserAgent ? 5 : navigator.maxTouchPoints, pageUrl);
const shell = requireElement<HTMLElement>(root, '.krc-shell');
const stage = requireElement<HTMLElement>(root, '#krc-stage');
const toast = createToast(requireElement(root, '#krc-toast'));

const createApp = (intake: IntakeApi) => createReportCardApp({ stage, shell, environment, intake, toast });

const preview = import.meta.env.DEV ? params.get('preview') : null;
if (import.meta.env.DEV && preview) {
  void import('./ui/preview').then(({ startPreview }) => startPreview(preview, createApp, createBrowserIntakeApi));
} else {
  createApp(createBrowserIntakeApi()).start();
}
